export default __webpack_public_path__ + "static/82723-2604aa4a95e613175769ac24688450b5.jpg";